var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositionIconDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "#161615"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41452 11.7512L8.88707 11.5878C8.83841 11.4471 8.72953 11.3353 8.59008 11.283L8.41452 11.7512ZM14.3319 4.68454L14.506 5.15326L14.3319 4.68454ZM15.436 5.81649L14.9718 5.63077L15.436 5.81649ZM4.06117 10.1187L3.8856 10.5869L4.06117 10.1187ZM4.06372 8.49821L3.88964 8.0295H3.88964L4.06372 8.49821ZM9.81058 15.7892L9.33803 15.9526L9.81058 15.7892ZM11.4309 15.8278L11.8951 16.0135L11.4309 15.8278ZM10.2831 15.6258L8.88707 11.5878L7.94196 11.9146L9.33803 15.9526L10.2831 15.6258ZM8.59008 11.283L4.23673 9.65053L3.8856 10.5869L8.23895 12.2194L8.59008 11.283ZM4.23781 8.96693L14.506 5.15326L14.1579 4.21583L3.88964 8.0295L4.23781 8.96693ZM14.9718 5.63077L10.9667 15.6421L11.8951 16.0135L15.9002 6.00221L14.9718 5.63077ZM14.506 5.15326C14.8027 5.04309 15.0893 5.33697 14.9718 5.63077L15.9002 6.00221C16.3399 4.9031 15.2676 3.80367 14.1579 4.21583L14.506 5.15326ZM4.23673 9.65053C3.92056 9.53196 3.92126 9.08449 4.23781 8.96693L3.88964 8.0295C2.70545 8.46931 2.70281 10.1433 3.8856 10.5869L4.23673 9.65053ZM9.33803 15.9526C9.751 17.1471 11.4257 17.187 11.8951 16.0135L10.9667 15.6421C10.8412 15.9558 10.3935 15.9451 10.2831 15.6258L9.33803 15.9526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIconDetail);
export default __webpack_public_path__ + "static/media/position-icon-detail.99b62ff16344aa7b5760ed97b2296699.svg";
export { ForwardRef as ReactComponent };